<template>
  <div>
    <div class="archive-head">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
    <div class="nsfc-details-container">
      <section class="main-container">
        <h1>{{detailsData.projectName}}</h1>
        <div class="details-item">
          <div class="describe">
            <div class="vertical-bar"></div>
            <div class="vertical-text">基本信息</div>
          </div>
          <div class="card full-card">
            <el-row>
              <el-col :span="4"> 项目批准号： </el-col>
              <el-col :span="20"> {{detailsData.ratifyNo}} </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"> 学科代码： </el-col>
              <el-col :span="20"> {{detailsData.applyCode ? detailsData.applyCode.code : ''}} </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"> 学科类别： </el-col>
              <el-col :span="20"> {{detailsData.applyCode ? detailsData.applyCode.name : ''}} </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"> 项目类别： </el-col>
              <el-col :span="20"> {{detailsData.projectType}} </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"> 负责人： </el-col>
              <el-col :span="20"> {{detailsData.projectAdmin}} </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"> 依托单位： </el-col>
              <el-col :span="20"> {{detailsData.dependUnit}} </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"> 批准年份： </el-col>
              <el-col :span="20"> {{detailsData.approvalYear}} </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"> 结题年份： </el-col>
              <el-col :span="20"> {{detailsData.endYear}} </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"> 资助经费（万元）： </el-col>
              <el-col :span="20"> {{detailsData.supportNum}} </el-col>
            </el-row>
            <el-row>
              <el-col :span="4"> 关键词： </el-col>
              <el-col :span="20"> {{detailsData.projectKeywordC.join(' ')}} </el-col>
            </el-row>
          </div>
        </div>
        <div class="details-item">
          <div class="describe">
            <div class="vertical-bar"></div>
            <div class="vertical-text">项目参与人</div>
          </div>
          <div class="card full-card">
            <el-table
              :data="detailsData.participatantsList"
              stripe
              border
              style="width: 500px">
              <el-table-column
                prop="name"
                label="姓名"
                width="200px">
              </el-table-column>
              <el-table-column
                prop="university"
                label="单位">
              </el-table-column>
            </el-table>
          </div>
          <!-- <el-row :gutter="20">
              <el-col :span="6" v-for="item in detailsData.participatantsList" :key="item.id" style="margin-bottom: 20px">
                  <div class="card small-card person-item">
                      <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" alt="" srcset="" width="80px">
                      <div class="person-info">
                          <h6>{{item.name}}</h6>
                          <p>{{item.university}}</p>
                      </div>
                  </div>
              </el-col>
          </el-row> -->
        </div>
        <div class="details-item">
          <div class="describe">
            <div class="vertical-bar"></div>
            <div class="vertical-text">项目摘要</div>
          </div>
          <div class="card full-card">
            <el-row>
              <el-col :span="4">中文摘要： </el-col>
              <el-col :span="20"> {{detailsData.projectAbstractC}} </el-col>
            </el-row>
            <el-row style="margin-top: 24px">
              <el-col :span="4">英文摘要： </el-col>
              <el-col :span="20"> {{detailsData.projectAbstractE}} </el-col>
            </el-row>
          </div>
        </div>
        <div class="details-item">
          <div class="describe">
            <div class="vertical-bar"></div>
            <div class="vertical-text">结题摘要</div>
          </div>
          <div class="card full-card">
            <article>{{detailsData.conclusionAbstract}}</article>
          </div>
        </div>
         <div class="details-item">
          <div class="describe">
            <div class="vertical-bar"></div>
            <div class="vertical-text">成果产出</div>
          </div>
          <div class="card full-card dashed-line" v-for="item in detailsData.resultsList" :key="item.id">
            <el-row>
              <h2 class="details-title">{{ item.title}}</h2>
            </el-row>
            <el-row>
              <el-col :span="24">类别：{{ item.name }} </el-col>
              <el-col :span="24">作者：{{item.type}}</el-col>
            </el-row>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { getDetailsData } from "@/api/nsfc";
export default {
  data() {
    return {
      detailsData: {}
    }
  },
  mounted() {
    this.getDetailsData()
  },
  methods: {
    getDetailsData() {
      const id = this.$route.query.id
      getDetailsData(id).then(res => {
        this.detailsData = res.data.data && res.data.data.length ? res.data.data[0] : {}
      })
    }
  }
};
</script>
<style lang="less">
.nsfc-details-container {
  .el-table th.el-table__cell {
    color: rgb(0, 32, 118);
    font-weight: 700;
  }
}
</style>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.archive-head {
  width: 100%;
  background-color: #0275d8;
  color: white;
  font-size: 16px;
  height: 50px;
  padding: 10px 15px;
  img {
    width: 100px;
  }
}
.nsfc-details-container {
  background: #f0f2f5;
  padding: 20px;
  min-height: calc(100vh - 50px);
  .main-container {
    margin: auto;
    max-width: 1440px;
    .details-item {
      // margin-bottom: 32px;
      margin-bottom: 20px;
    }
    h1 {
      font-size: 30px;
      color: #000;
      line-height: 36px;
      margin-bottom: 24px;
      word-wrap: break-word;
    }
    .describe {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      .vertical-bar {
        width: 4px;
        height: 16px;
        background: #0275d8;
        margin-right: 8px;
      }
      .vertical-text {
        line-height: 15px;
        font-size: 15px;
        font-weight: 800;
        // color: #303030;
        color: #000;

      }
    }
    .card {
      // background: #fff;
      // box-shadow: 6px 6px 10px 2px rgba(218, 224, 237, 0.8);
      // border-radius: 18px;
      font-size: 14px;
      .el-row {
        margin-bottom: 4px;
      }
    }
    
    .full-card {
      // padding: 20px 24px;
      padding: 20px 0;
      // margin-bottom: 16px;
      border-bottom: 1px solid #ddd ;
    }
    .dashed-line {
      border-bottom: 1px dashed #ddd;
    }
    .small-card {
        padding: 20px 16px;
    }
    .details-title {
        font-weight: 600;
        font-size: 15px;
        color: rgb(0, 32, 118);
    }
     .person-item {
         display: flex;
         align-items: center;
         img {
             margin-right: 12px;
         }
         h6 {
             font-size: 16px;
                color: rgb(0, 32, 118);
             margin-bottom: 6px;
         }
     }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/nsfcSearch/details.vue